import React, { useState, useContext } from "react";
import { Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { Select } from "components/Form/Field";
import { Options } from "ui/Form/Element/Select";
import { IntlContext } from "context";
import ListAlimentaire from "./List";
import ListAlimentaireMarque from "./ListWithMarque";
import Diagram from "../Diagram";
import Tooltip from "ui/Form/Element/Tooltip";
import { matomoPush } from "../../Produit/helpers";

const ViewDataRouter: React.FC<{ activeFilters: any, filtersMax: any }> = ({ activeFilters, filtersMax }) => {
    const intl = useContext(IntlContext);

    enum displayView {
        ALIMENTAIRE = "alimentaire",
        NUTRITIONNELLE = "nutritionnelle",
    }
    const [viewSelected, setViewSelected] = useState<string>(displayView.ALIMENTAIRE);
    const typeMarque = activeFilters?.filter_type_marque?.length || 0;
    const displayViews: Array<Options> = [
        {
            label: intl.formatMessage("produit.view_data.alimentaire.title"),
            value: displayView.ALIMENTAIRE,
        },
        {
            label: intl.formatMessage("produit.view_data.nutritionnelle.title"),
            value: displayView.NUTRITIONNELLE,
        },
    ];

    matomoPush([
        ["setReferrerUrl", window.location.href],
        ["setCustomUrl", `${window.location.href}/offre_alimentaire`],
    ]);

    return (
        <React.Fragment>
            <div className="stats">
                <div className="container container--table">
                    <div className="flex margin-bottom--4">
                        <h1>{intl.formatMessage("produit.view_data.display_data")}</h1>
                    </div>
                    <Form
                        autoComplete="off"
                        mutators={{ ...arrayMutators }}
                        onSubmit={(values) => {}}
                        render={({ form, handleSubmit }) => {
                            return (
                                <form onSubmit={handleSubmit}>
                                    <div style={{ display: "flex" }}>
                                        <Select
                                            inputProps={{
                                                name: "filter_select_data",
                                                options: displayViews,
                                                value: viewSelected,
                                                onChange: (e) =>
                                                    setViewSelected(e.target.value || displayView.ALIMENTAIRE),
                                            }}
                                            type="select"
                                            multiple={false}
                                        />
                                        {viewSelected && (
                                            <div>
                                                <Tooltip
                                                    value={
                                                        displayView.NUTRITIONNELLE === viewSelected
                                                            ? intl.formatMessage(
                                                                  "produit.view_data.nutritionnelle.help"
                                                              )
                                                            : intl.formatMessage("produit.view_data.alimentaire.help")
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                </form>
                            );
                        }}
                    />
                    {!!typeMarque && viewSelected === displayView.ALIMENTAIRE && (
                        <ListAlimentaireMarque activeFilters={activeFilters} />
                    )}
                    {!typeMarque && viewSelected === displayView.ALIMENTAIRE && (
                        <ListAlimentaire activeFilters={activeFilters} />
                    )}
                    {viewSelected === displayView.NUTRITIONNELLE && <Diagram activeFilters={activeFilters} filtersMax={filtersMax} />}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ViewDataRouter;
